import { Component, h, Prop, Host } from '@stencil/core';
import { align_center } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-product-tile-info',
  styleUrl: 'pn-product-tile-info.scss',
})
export class PnProductTileInfo {
  @Prop() label: string;
  @Prop() text: string;
  @Prop() icon: string;
  render() {
    return (
      <Host>
        {this.label ? (
          <p>
            <small>{this.label}</small>
          </p>
        ) : null}
        {this.text ? <h3>{this.text}</h3> : null}
        {/* {(this.icon) ? (<pn-icon icon={this.icon} color=""></pn-icon>) : null} */}
      </Host>
    );
  }
}
<pn-icon icon={align_center} small="false" color="black" />;
